import { api } from './api'
import { moneyObjectHeader } from './money-object-header'

export const completeTransaction = (id: string | number) =>
  api.put(`/transactions/${id}/complete`, undefined, { headers: moneyObjectHeader })
